import PropTypes from "prop-types"

import { SkuIcon } from "areas/product/wizard-options/components"

const metalMap = {
  CER: {
    skuColor: "CE",
    value: "CE",
  },
  SS14KYP: {
    skuColor: "YGP",
    value: "14K",
  },
  SS18KYP: {
    skuColor: "YGP",
    value: "18K",
  },
  SSRGP: {
    skuColor: "R",
    value: "R",
  },
  SST18KYT: {
    skuColor: "YGP",
    value: "18K",
  },
  VERMY: {
    skuColor: "V",
    value: "V",
  },
}

const MetalIcon = ({ metal }) => {
  const mappedMetal = metalMap[metal.value]

  if (mappedMetal) {
    return (
      <SkuIcon skuColor={mappedMetal.skuColor}>{mappedMetal.value}</SkuIcon>
    )
  }

  return (
    <SkuIcon skuColor={metal.imageKey.slice(-1)}>{metal.icon_text}</SkuIcon>
  )
}

MetalIcon.propTypes = {
  metal: PropTypes.object,
}

export default MetalIcon
